document.addEventListener('DOMContentLoaded', function() {
	const swatchSize = parseInt($('#ega-product-detail .ega-swatch__wrapper').children().size());
	$(document).on('click','#ega-product-detail .ega-swatch label:not(.soldout)', function(e) {
		e.preventDefault();
		const $this = $(this);
		let available = '';

		$this.parent().siblings().find('label').removeClass('active');
		$this.addClass('active');

		const name = $this.data('name');
		const value = $this.data('value');

		$(`#ega-product-detail select[data-option='${name}']`).val(value).trigger('change');
		if (swatchSize === 2) {
			if (name.indexOf('1') > -1) {
				$('#ega-product-detail #variant-swatch-1 .ega-swatch__element label').removeClass('active');
				$('#ega-product-detail #variant-swatch-1 .ega-swatch__element label').removeClass('soldout');
				$('#ega-product-detail .selector-wrapper .single-option-selector').eq(1).find('option').each(function() {
					let selectorVal = $(this).val();
					$(this).parent().val(selectorVal).trigger('change');
					if (checkVariant) {
						if (available === '') {
							available = selectorVal;
						}
					} else {
						$(`#ega-product-detail #variant-swatch-1 .ega-swatch__element[data-value='${selectorVal}'] label`).addClass('soldout');
					}
				})
				$('#ega-product-detail .selector-wrapper .single-option-selector').eq(1).val(available).trigger('change');
				$(`#ega-product-detail #variant-swatch-1 .ega-swatch__element[data-value='${available}'] label`).addClass('active');

				// click on label
				$(`#ega-product-detail #variant-swatch-1 .ega-swatch__element[data-value='${available}'] label`).click();
			}
		} else if (swatchSize === 3) {
			const countOption3 = $('#ega-product-detail #variant-swatch-2 .ega-swatch__element').size();
			if (name.indexOf('1') != -1) {
				$('#ega-product-detail #variant-swatch-1 .ega-swatch__element label').removeClass('active');
				$('#ega-product-detail #variant-swatch-1 .ega-swatch__element label').removeClass('soldout');
				$('#ega-product-detail #variant-swatch-2 .ega-swatch__element label').removeClass('active');
				$('#ega-product-detail #variant-swatch-2 .ega-swatch__element label').removeClass('soldout');

				let availableOption1 = '';
				let availableOption2 = '';
				$('#ega-product-detail #variant-swatch-1 .ega-swatch__element').each(function(index, value) {
					const key = $(this).data('value');
					let unavailable = 0;
					$('#ega-product-detail .single-option-selector').eq(1).val(key).change();
					$('#ega-product-detail #variant-swatch-2 .ega-swatch__element label').removeClass('active');
					$('#ega-product-detail #variant-swatch-2 .ega-swatch__element label').removeClass('soldout');
					$('#ega-product-detail #variant-swatch-2 .ega-swatch__element').each(function(i, v) {
						const val = $(this).data('value');
						$('#ega-product-detail .single-option-selector').eq(2).val(val).change();
						if (checkVariant === true) {
							if (availableOption1 === '') {
								availableOption1 = key;
							}
							if (availableOption2 === '') {
								availableOption2 = val;
							}
						} else {
							unavailable += 1;
						}
					})
					if (unavailable === countOption3) {
						$(`#ega-product-detail #variant-swatch-1 .ega-swatch__element[data-value = '${key}'] label`).addClass('soldout');
					}
				})
				$(`#ega-product-detail #variant-swatch-1 .ega-swatch__element[data-value='${availableOption1}'] label`).click();
			}
			else if (name.indexOf('2') != -1) {
				$('#ega-product-detail #variant-swatch-2 .ega-swatch__element label').removeClass('active');
				$('#ega-product-detail #variant-swatch-2 .ega-swatch__element label').removeClass('soldout');
				$('#ega-product-detail .selector-wrapper .single-option-selector').eq(2).find('option').each(function() {
					var selectorVal = $(this).val();
					$(this).parent().val(selectorVal).trigger('change');
					if (checkVariant) {
						if (available === '' ) {
							available = selectorVal;
						}
					} else {
						$(`#ega-product-detail #variant-swatch-2 .ega-swatch__element[data-value='${selectorVal}'] label`).addClass('soldout');
					}
				})
				$('#ega-product-detail .selector-wrapper .single-option-selector').eq(2).val(available).trigger('change');
				$(`#ega-product-detail #variant-swatch-2 .ega-swatch__element[data-value='${available}'] label`).addClass('active');

				// click on label
				$(`#ega-product-detail #variant-swatch-2 .ega-swatch__element[data-value='${available}'] label`).click();
			}
		} else {

		}
	})

	// choose first available option
	const optionVal1 = $('#ega-product-detail .selector-wrapper .single-option-selector').eq(0).val();
	const optionVal2 = $('#ega-product-detail .selector-wrapper .single-option-selector').eq(1).val();
	$(`#ega-product-detail .ega-swatch__element[data-value='${optionVal1}']`).find('label').click();
	$(`#ega-product-detail .ega-swatch__element[data-value='${optionVal2}']`).find('label').click();
	if (swatchSize === 2) {
		let availableOption1 = '';
		let availableOption2 = '';
		const swatchCount1 = $('#ega-product-detail #variant-swatch-1 .ega-swatch__element').size();
		$('#ega-product-detail #variant-swatch-0 .ega-swatch__element').each(function(index, value) {
			const key = $(this).data('value');
			let unavailable = 0;
			$('#ega-product-detail .single-option-selector').eq(0).val(key).change();
			$('#ega-product-detail #variant-swatch-1 .ega-swatch__element').each(function(i, v) {
				var val = $(this).data('value');
				$('#ega-product-detail .single-option-selector').eq(1).val(val).change();
				if (checkVariant === true) {
					if (availableOption1 === '') {
						availableOption1 = key;
					}
					if (availableOption2 === '') {
						availableOption2 = val;
					}
				} else {
					unavailable += 1;
				}
			})
			if (unavailable === swatchCount1) {
				$(`#ega-product-detail #variant-swatch-0 .ega-swatch__element[data-value = '${key}'] label`).addClass('soldout');
			}
		})
		$(`#ega-product-detail #variant-swatch-1 .ega-swatch__element[data-value = '${availableOption2}'] label`).click();
		$(`#ega-product-detail #variant-swatch-0 .ega-swatch__element[data-value = '${availableOption1}'] label`).click();
	} else if (swatchSize === 3) {
		let availableOption1 = '';
		let availableOption2 = '';
		let availableOption3 = '';
		const sizeOption2 = $('#ega-product-detail #variant-swatch-1 .ega-swatch__element').size();
		const sizeOption3 = $('#ega-product-detail #variant-swatch-2 .ega-swatch__element').size();

		$('#ega-product-detail #variant-swatch-0 .ega-swatch__element').each(function(index, value) {
			const key1 = $(this).data('value');
			let countUnavailable = 0;
			$('#ega-product-detail .single-option-selector').eq(0).val(key1).change();
			$('#ega-product-detail #variant-swatch-1 .ega-swatch__element').each(function(i,v) {
				const keyVal2 = $(this).data('value');
				let unavailable2 = 0;
				$('#ega-product-detail .single-option-selector').eq(1).val(keyVal2).change();
				$('#ega-product-detail #variant-swatch-2 .ega-swatch__element').each(function() {
					const keyVal3 = $(this).data('value');
					$('#ega-product-detail .single-option-selector').eq(2).val(keyVal3).change();
					if (checkVariant == true) {
						if (availableOption1 == '') {
							availableOption1 = key1;
						}
						if (availableOption2 == '') {
							availableOption2 = keyVal2;
						}
						if (availableOption3 == '') {
							availableOption3 = keyVal3;
						}
					} else {
						unavailable2 += 1;
					}
				})
				if (unavailable2 == sizeOption3) {
					countUnavailable += 1;
				}
			})
			if (sizeOption2 == countUnavailable) {
				$(`#ega-product-detail #variant-swatch-0 .ega-swatch__element[data-value='${key1}'] label`).addClass('soldout');
			}
		})
		$(`#ega-product-detail #variant-swatch-0 .ega-swatch__element[data-value='${availableOption1}'] label`).click();
	}

	const val = $('#ega-product-detail .ega-swatch .color label').val();
	$('#ega-product-detail .ega-swatch .color label').parents(".ega-swatch").find(".header span").html(val);
	$("#ega-product-detail .ega-swatch__swap .color" ).hover(function() { 
		const value = $(this).data("value");
		$(this).parents(".ega-swatch").find(".header span").html(value);
	}, function() {
		const value = $("#ega-product-detail .ega-swatch__swap .color label.active span").html();
	});

	// Change slide when click on color
	$(document).on('click', '#ega-product-detail .ega-swatch .color label:not(.soldout)', function(e) {
		const color = $(this).data('vhandle');
		let newImagesArr = [];
		let html = '';
		if (product.images && product.images.length > 1) {
			product.images.map(image => {
				if (image.indexOf(color) > -1) {
					newImagesArr.push(image);
				}
			})

			if (newImagesArr.length > 0) {
				destroySlider();
				const $thumb = $('.ega-pro--detail .ega-pro__thumb');
				$thumb.html('');
				const $thumbClone = $('.ega-pro--detail .ega-pro__thumb').clone().insertAfter('.ega-pro--detail .ega-pro__thumb');

				$thumb.remove();

				newImagesArr.map(newImage => {
					html += '<div class="ega-pro__thumb-item">';
					html += '<img data-image="' + newImage + '"';
					html += 'data-src="' + Haravan.resizeImage(newImage, 'grande') + '"';
					html += 'src="' + Haravan.resizeImage(newImage, 'grande') +'"/>';
					html += '</div>';
				})

				$thumbClone.html(html);
				initSlider();
			}
		}
	})

	// Click on active color to init image slider.
	$('#ega-product-detail .ega-swatch .color label.active').prev().click();
});
